
<div class="input-group mb-3">
    <input name="filterText" [disabled]="!isAllowEdit" type="text" [(ngModel)]="data"
        class="form-control" ><button type="button" (click)="openCkfinder()"
        class="btn btn-primary"><i class="flaticon-folder-1"></i></button>
        <button class="btn btn-danger btn-icon" type="button"
        (click)="setPathNull()"><i class="fa fa-times"></i></button>
</div>
